import { createAction } from "redux-act";
export const setPrimaryTool = createAction("SET_PRIMARY_TOOL", (gameId, toolId) => ({ gameId, toolId }));
export const setToolOrder = createAction("SET_TOOLS_ORDER", (gameId, tools) => ({ gameId, tools }));
export const setToolValid = createAction("SET_TOOL_IS_VALID", (gameId, toolId, valid) => ({
    gameId,
    toolId,
    valid,
}));
export const setToolPinned = createAction("SET_TOOL_PINNED", (gameId, toolId, pinned) => ({
    gameId,
    toolId,
    pinned,
}));
